import React from 'react';
import PropTypes from 'prop-types';
import Filter from 'common/components/responsive/filter'

const SortSection = ({
   value,
   options,
   isMobile,
   onChange,
   name,
}) => {
   const getActiveOptionName = () => {
      const activeValue =  options.find(option => option.value === value) || {};
      return activeValue?.name || '';
   }
   return (
      <div
         className='flex'
      >
         <Filter
            type='sort'
            onClickShowResult={ () => {} }
            onClickClear={ () => {
            } }
            height='10'
            contentStyles={ {
               right: '0px',
               top: '44px',
               width: '100%',
            } }
            filterClassName='flex-none w-full'
            className='w-full'
            textWrapperClassName='justify-between'
            hasClearButton={ false }
            hasFilterButtonContent={ false }
            isAutoSave
            disabledOptionTooltiptext='This view cannot be reordered'
            desktopType={ isMobile ? 'mobile' : 'desktop' }
            showNewStyles
            name={ getActiveOptionName() }
            activeSelectedValue={ {
               value: value,
            } }
            data={ options || []  }
            onFilterChange={ (value) => {
               onChange(name, value)
            } }
         />
      </div>
   );
};


SortSection.propTypes = {
   value: PropTypes.string,
   onChange: PropTypes.func,
   name: PropTypes.string,
   // inputProps: PropTypes.object,
   options: PropTypes.array,
   isMobile: PropTypes.bool,
};
SortSection.defaultProps = {

}

export default SortSection;
